import { DatePipe, JsonPipe } from '@angular/common';
import { Component, Input, OnInit, WritableSignal, effect, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AgeStringPipe } from '../../../../pipes/age-string.pipe';
import { AssessmentNotesPipe } from '../../../../pipes/assessment-notes.pipe';
import { GenderStringPipe } from '../../../../pipes/gender-string.pipe';
import { MonthStringPipe } from '../../../../pipes/month-string.pipe';
import { AssessmentsService } from '../../../../services/assessments.service';
import { Assessment, Patient } from '../../../../services/model';
import { PatientsService } from '../../../../services/patients.service';
import { AssessmentScorePipe } from '../../../../pipes/assessment-score.pipe';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-assessment-table-old',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    JsonPipe,
    MatTableModule,
    MonthStringPipe,
    GenderStringPipe,
    AgeStringPipe,
    DatePipe,
    AssessmentNotesPipe,
    AssessmentScorePipe,
    MatIconModule,
    MatProgressBarModule,
    RouterModule,
    MatMenuModule,
    MatTabsModule,
  ],
  templateUrl: './assessment-table.component.html',
  styleUrl: './assessment-table.component.scss',
})
export class AssessmentTableComponent implements OnInit {
  @Input() patientId?: string;
  patient: WritableSignal<Patient | undefined> = signal(undefined);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private snackBar: MatSnackBar = inject(MatSnackBar);
  private assessmentsService: AssessmentsService = inject(AssessmentsService);
  private patientsService: PatientsService = inject(PatientsService);

  assessmentList: WritableSignal<Assessment[]> = this.assessmentsService.assessmentList;

  tableColumns = ['date', 'type', 'score', 'note', 'buttons'];

  constructor() {
    // effect(() => {
    //   console.log('effect-assessmentlist() ', this.assessmentList());
    // });
  }

  ngOnInit(): void {
    // console.log('patientID', this.patientId);
    if (this.patientId !== undefined) {
      this.patientsService.getPatient(this.patientId).then(patient => {
        this.patient.set(patient);
        this.assessmentsService.getAssessments();
      });
    }
  }

  newAssessment() {
    this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
  }

  navigateToAssessment(assessment: Assessment) {
    console.log('ass', assessment);
    if (assessment) {
      this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
        relativeTo: this.route,
      });
    }
  }

  deleteAssessment(assessment: Assessment) {
    if (assessment?._documentId) {
      this.assessmentsService.deleteAssessment(assessment._documentId);
    }
  }

  search() {}
}
